import script from "./HeroCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroCarousel.vue?vue&type=script&setup=true&lang=js"

import "./HeroCarousel.vue?vue&type=style&index=0&id=2818628c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2818628c"]])

export default __exports__